import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  slug: string;
  author: string;
  cover: string;
  rating: number;
  status: string;
  chapters: number;
  category: string;
}

export default function ComicCard({ title, slug, author, cover, rating, status, chapters }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${slug}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] bg-background-100">
        <img
          src={cover}
          alt={`${title} - 韩国漫画完整版免费阅读`}
          title={`${title} - 无删减漫画下拉观看`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-white text-xs font-medium px-2 py-1 rounded-full bg-primary-500/90 whitespace-nowrap">
            点击阅读
          </span>
        </div>
        <div className="absolute top-2 left-2">
          <span className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
            status === '已完结'
              ? 'bg-accent-100 text-accent-900'
              : 'bg-primary-500/90 text-white'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-black/60 backdrop-blur-sm rounded-full px-2 py-0.5">
          <i className="ri-star-fill text-yellow-400 text-xs"></i>
          <span className="text-white text-xs font-medium">{rating}</span>
        </div>
      </div>
      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1 truncate">{author}</p>
        <div className="flex items-center justify-between mt-1.5">
          <span className="text-xs text-foreground-500">共{chapters}话</span>
        </div>
      </div>
    </Link>
  );
}